$(() => {
    const $dropdowntilesdropdownlink = $('.dropdown-tiles .dropdown-link');
    const $faqdropdownlink = $('.faq .dropdown-link');

    const dropdowntoggle = ($dropdownlink) => {
        $dropdownlink.on('click', function() {
            slideToggle($(this));
        });
    };

    dropdowntoggle($dropdowntilesdropdownlink);
    dropdowntoggle($faqdropdownlink);
});
